// components/FontPreloader.jsx
import React from 'react';

const fonts = ["BananaGrotesk-Medium", "BananaGrotesk-Regular", "BananaGrotesk-Semibold", "BananaGrotesk-Light", "BananaGrotesk-Bold", "BananaGrotesk-Extralight", "BananaGrotesk-Extrabold", "BananaGrotesk-Medium", "BananaGrotesk-Thin"];

const FontPreloader = () => (
    <>
        {fonts.map(font => (
            <React.Fragment key={font}>
                <link rel="preload" href={`/fonts/${font}.woff2`} as="font" type="font/woff2" crossOrigin="anonymous" />
                <link rel="preload" href={`/fonts/${font}.woff`} as="font" type="font/woff" crossOrigin="anonymous" />
            </React.Fragment>
        ))}
    </>
);

export default React.memo(FontPreloader);
